import { Component, Input, OnInit } from '@angular/core';
import { enableLogging } from '../../../environments/environment';
import "firebase/analytics";
import firebase from "firebase/app";
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ProductService } from 'src/app/_services/product-service.service';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
@Input() classList = '';
@Input() text = '';
@Input() link='';
@Input() href='';

  constructor(private router: Router, private productService: ProductService) {

   }

  ngOnInit(): void {
    console.log('href', this.href)
  }
  eventHandler(){

    // const navEndEvents = this.router.events.pipe(
    //   filter((event) => event instanceof NavigationEnd)
    // );
    const analytics = firebase.analytics();

      console.log('new event should be fired ');

      analytics.logEvent(`download full paper for ${window.location.hostname.split('.')[0]}`, {
        productName:  window.location.hostname.split('.')[0]
      });

 }

 sameProduct(){
   this.productService.emitSameProduct(this.link);
 }


}
